<template>
  <div class="container">
    <div class="quantity">
      <v-form-number
        name="quantity"
        type="price"
        class="quantity__input"
        :value="inputValue"
        ref="limitTriggerIp"
        :step="increment"
        @input="onInput"
        @keydown.native.tab="onTabNavigation"
        :maximumFractionDigits="5"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'trigger-custom-editor',
  data() {
    return {
      inputValue: 0,
      disabledStyle: ' {color:#ffffff; background-color:none; border-color:none}',
      isValidInput: false,
      controlPressed: false,
      valuePasted: false
    };
  },
  methods: {
    cleanValueForOrders(val, decimalSeparator) {
      if (typeof val === 'number') return val;
      if (!val || val === '-') return '';
      if (decimalSeparator === ',') val = val.replace(/,(?=[^,]+$)/, '.');
      val = val.replace(/[^\d.-]/g, ''); // cleanup number from char debris
      return val ? Number(val) : '';
    },
    getDecimalDigits(value) {
      if (value) {
        if (Math.floor(value) === value) return 2;
        else {
          let valueStr = value.toString();
          return valueStr.indexOf('.') > 0 ? valueStr.split('.')[1].length : 2;
        }
      } else return 0;
    },
    getValue() {
      return this.inputValue;
    },

    setTriggerPrice() {
      if (this.params.data.extendedTerms.orderType.startsWith('TRAILING_STOP')) {
        if (this.params.data.extendedTerms.trailingStopTerms.deltaAmount) {
          this.params.data.extendedTerms.trailingStopTerms.deltaAmount = this.inputValue;
        } else {
          this.params.data.extendedTerms.trailingStopTerms.deltaPercent = this.inputValue;
        }
      } else if (this.params.data.extendedTerms.orderType.startsWith('STOP')) {
        this.params.data.extendedTerms.triggerPrice = this.inputValue;
      }
    },
    setLimitPrice() {
      if (this.params.data.strategy === 'MLO') {
        this.params.data.multilegEntry.extendedTerms.limitPrice = this.inputValue;
      } else {
        if (this.params.data.extendedTerms.orderType.startsWith('TRAILING_STOP')) {
          this.params.data.extendedTerms.trailingStopTerms.limitDelta = this.inputValue;
        } else {
          this.params.data.extendedTerms.limitPrice = this.inputValue;
        }
      }
    },
    onInput(value) {
      if (!value) {
        this.inputValue = this.params.originalValue;
      } else {
        const formattedValue = this.cleanValueForOrders(value, this.decimalSeparator);
        const floatingPointIp = this.getDecimalDigits(formattedValue);
        this.inputValue = parseFloat(formattedValue).toFixed(Math.max(floatingPointIp, this.defaultFloating));
        this.params.colDef.field === 'trigger' ? this.setTriggerPrice() : this.setLimitPrice();
        this.params.context.triggerInlineEditChange(this.params, this.inputValue);
      }
    },
    onTabNavigation(event) {
      this.params.api.stopEditing();
      if (event.shiftKey) this.params.api.tabToPreviousCell();
      else this.params.api.tabToNextCell();
    }
  },
  mounted() {
    this.inputValue = this.params.value || '';
  },
  computed: {
    increment() {
      if (this.params.data.security.type === 'EQUITY') {
        return parseFloat(this.$store.state.applicationSettings.orders.settings.stocks.defaultPriceIncrement);
      } else if (this.params.data.security.type === 'OPTION') {
        return parseFloat(this.$store.state.applicationSettings.orders.settings.options.defaultPriceIncrement);
      }
      return 1;
    },
    defaultFloating() {
      return this.getDecimalDigits(this.increment);
    },
    decimalSeparator() {
      return this.$n ? this.$n('0.1')[1] : '.';
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 67px;
  position: relative;
  bottom: 2.2px;
}
.quantity {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.quantity__input {
  width: calc-em(120px);
  height: calc-em(23px);
  margin: 0;
  padding: 0;
  text-align: center;
  color: $input-color;
  background: $input-bg;
  background-clip: padding-box;
  border: $input-border-width solid $input-border-color;
  border-radius: 0;
  align-items: center;
}
</style>
